module.exports = __webpack_public_path__ + "img/orders.9ddd32ef.svg";